import { useCallback } from "react";
import { KanaListenCounts } from "../utils/kanaListenCountsStorage";
import { useDeviceProgress } from "./useDeviceProgress";

export function useKanaListenCounts() {
    const { data: counts, update, syncStatus, cloudLoadFailed } = useDeviceProgress<KanaListenCounts>("kanaListenCounts", true);
    const increment = useCallback((key: string) => { void update({ kind: "increment", key }); }, [update]);
    return { counts, increment, syncStatus, cloudLoadFailed };
}
